import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { onSaveImageData } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { ImageSaveType } from '../../../../redux-store/types/nct';
import { OTP_ACTIONS } from '../../../../utils/constants';
import UploadDocumentScreen from '../UploadDocumentScreen';
const { dashboard } = en;

function ChangeMobileDocument(props: any) {
    const [Document, setDocument] = useState<any>({
        image: { name: 'MOBILE_CHANGE', format: '', content: '' },
    });

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
    }, []);

    const handleImageSelection = (value: any, format: any) => {
        setDocument({
            image: {
                ...Document.image,
                format: format,
                content: value,
            },
        });
    };

    const handleSubmission = () => {
        props.history.replace('change-mobile-new', {
            images: [Document.image],
            action: OTP_ACTIONS.NEW_MOBILE_OFFLINE_OTP,
            ...(props?.location?.state || {}),
        });
    };

    // save image in store
    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: [Document.image],
                type: 'CHANGE_MOBILE',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [Document]);

    return (
        <div className="curved-bg">
            <UploadDocumentScreen
                backLink="nct/change-mobile"
                heading={dashboard.ChangeMobile.ChangeMobileHeading}
                subheading={dashboard.ChangeMobile.UploadDocument.subHeading}
                linkText={dashboard.ChangeMobile.UploadDocument.subHeadingInfo2}
                info1={dashboard.ChangeMobile.UploadDocument.subHeadingInfo1}
                info2={dashboard.ChangeMobile.UploadDocument.subHeadingInfo3}
                nextLink="change-mobile-new"
                id="upload-scanned-document"
                onImageSelected={handleImageSelection}
                handleSubmit={handleSubmission}
                isDisabled={!!Document.image.content}
                hrefLink={process.env.REACT_APP_S3_CLOUD_URL + '/Updation_of_Mobile_No.docx'}
            />
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { onSaveImageData },
)(ChangeMobileDocument);
